import api from "./api";

export interface LoginCredentials {
  email: string;
  password: string;
}

export interface RegisterData {
  name: string;
  email: string;
  password: string;
  role?: "admin" | "manager" | "staff";
}

export interface User {
  id: string;
  name: string;
  email: string;
  role: string;
  lastLogin?: string;
  createdAt?: string;
}

export interface CustomerInfo {
  id: string;
  name: string;
  code: string;
}

export interface AuthResponse {
  success: boolean;
  message: string;
  token: string;
  user: User;
  customer?: CustomerInfo;
  pharmacyName?: string;
}

class AuthService {
  async login(credentials: LoginCredentials): Promise<AuthResponse> {
    const response = await api.post("/auth/login", credentials);
    return response.data;
  }

  async register(userData: RegisterData): Promise<AuthResponse> {
    const response = await api.post("/auth/register", userData);
    return response.data;
  }

  async getProfile(): Promise<{
    success: boolean;
    user: User;
    customer?: CustomerInfo;
    pharmacyName?: string;
  }> {
    const response = await api.get("/auth/me");
    return response.data;
  }

  async updateProfile(userData: {
    name: string;
    email: string;
  }): Promise<{ success: boolean; user: User; message: string }> {
    const response = await api.put("/auth/profile", userData);
    return response.data;
  }

  async changePassword(passwordData: {
    currentPassword: string;
    newPassword: string;
  }): Promise<{ success: boolean; message: string }> {
    const response = await api.put("/auth/change-password", passwordData);
    return response.data;
  }

  logout(): void {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("customer");
    localStorage.removeItem("pharmacyName");
    window.location.href = "/login";
  }

  getToken(): string | null {
    return localStorage.getItem("token");
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    return !!token;
  }

  getCurrentUser(): User | null {
    const userString = localStorage.getItem("user");
    return userString ? JSON.parse(userString) : null;
  }
}

export default new AuthService();
